<template>
  <div class="refund-wrap"   :class="{'grey': values.asset.endsWith('20D')}">
    <md-dialog-title>{{ i18n.lbl_refund() }}<span class="orange" v-if="status.status === 'in_progress'"> — {{ i18n.lbl_refund_pending() }}</span></md-dialog-title>
    <div class="refund-content">
      <detail :prop="i18n.lbl_balance()"  :capitalize="true" :value="`${status.source_balance} ${token}`" />
      <detail :prop="i18n.lbl_refund_amount()"  :capitalize="true" :value="`${status.refund_amount} ${token}`" />
      <detail :prop="i18n.lbl_commision()"  :capitalize="true" :value="`${status.refund_commission} ${token}`" />
      <detail :prop="i18n.lbl_address_refund()" v-if="status.refund_wallet" :value="status.refund_wallet" />
      <input-field class="md-layout-item"
        :class="{'grey': values.asset.endsWith('20D')}"
        v-if="!status.auto_execute_at"
        v-model.trim="wallet"
        :label="`${i18n.lbl_address()} ${token}`"
        :name="values.asset"
        :id="values.asset"
        :autocomplete="false"
        v-validate="`required|${addressRuleFor(values.asset)}`"
        :errorMessage="errors.first(values.asset)"
      />
      <div class="mt-30" v-if="status.auto_execute_at && status.status !== 'in_progress'">
        <RefundTimer :timer="status.auto_execute_at" @action="refundImmidiet"/>
      </div>
      <md-dialog-actions class="refund-timer" v-if="status.auto_execute_at && status.status !== 'in_progress'">
        <md-button class="btn md-primary" :disabled="isDisabledCancel" @click="cancelRefund">{{ i18n.lbl_cancel_refund() }}</md-button>
        <md-button class="btn md-primary" :disabled="isDisabledCancel" @click="refundImmidiet(true)">{{ i18n.lbl_send_immediatly() }}</md-button>
      </md-dialog-actions>
      <md-dialog-actions>
        <md-button class="md-button btn md-primary md-theme-default" :disabled="isDisabledRefund"  @click="refundStart" v-if="!status.auto_execute_at">{{ i18n.lbl_refund() }}</md-button>
        <md-button class="md-button btn md-primary md-theme-default" :disabled="isDisabledCancel" @click="$emit('close')">{{ i18n.lbl_cancel() }}</md-button>
      </md-dialog-actions>
  </div>
</div>
</template>

<script>
/* eslint-disable */
import InputField from '@com/fields/InputField'
import { createTfaDialog } from '@js/modals/tfa_dalog.modal'
import { createPasswordDialog } from '@js/modals/password_dialog.modal'
import { createTfaRecoveryDialog } from '@js/modals/tfa_recovery.modal'
import { errors } from '@js/errors/factory'
import { parseError } from '@js/parsers/error.parser'
import common from '@api/common/common'
import { vuexTypes } from '@vuex/types'
import { getTokenNetwork, addressRuleFor } from '@utils/consts'
import { i18n } from '@js/i18n'
import { mapGetters, mapActions } from 'vuex'
import Detail from '@vue/app/common/Detail.Row'
import RefundTimer from '../app/timer/RefundTimer.vue'
import apiHelper from '@utils/cunstomInterseptor'

export default {
  name: 'RefundModal',
  emits: ['setIsLoading', 'close', 'refreshStatus', 'deleteNotif', 'toggleError'],
  components: { Detail, InputField, RefundTimer },
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    values: {
      type: Object,
      required: true
    },
    status: {
      type: Object,
      required: true
    },
    token: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      i18n,
      wallet: ''
    }
  },
  methods: {
    addressRuleFor,
    ...mapActions({
      commitTfa: vuexTypes.SET_FACTOR_DATA
    }),
    async startTfa (error) {
      const parsedError = parseError(error)
      switch (parsedError.constructor) {
        case errors.OtpError:
          this.commitTfa(vuexTypes.SET_FACTOR_DATA, parsedError.meta)
          return createTfaDialog(this.refundStart.bind(this), parsedError.meta, true)

        case errors.TFARecoveryError:
          return createTfaRecoveryDialog(this.refundStart.bind(this), parsedError.meta)

        case errors.PasswordFactorError:
          const email = this.userEmail
          const kdf = await common.getWalletKDF(email)

          return createPasswordDialog(
            this.refundStart.bind(this), {
              ...parsedError.meta,
              kdf: kdf.attributes(),
              email
            })

        default:
          return Promise.reject(parsedError)
      }
    },
    async refundStart (params = '') {
      if (this.errors.items.length) return
      try {
        this.$emit('toggleError', false)
        this.$emit('setIsLoading', true)
        await apiHelper.post('/refund/create', {
          source_wallet: this.status.source_wallet,
          refund_wallet: this.wallet,
          refund_deposits: [...this.status.refund_deposits],
          otp_code: params.token ? params.token : ''
        }) 
        await this.$emit('refreshStatus')
      } catch (error) {
        if (error.response.status === 403) {
          this.startTfa(error)
        }
        this.$emit('toggleError', true)
        this.$emit('setIsLoading', false)
        throw parseError(error)
      } finally {
        this.errors.clear()
        this.$emit('setIsLoading', false)
      }
    },
    async refundImmidiet (close = false) {
      try {
        this.$emit('toggleError', false)
        this.$emit('setIsLoading', true)
        await apiHelper.post('/refund/execute', {
          source_wallet: this.status.source_wallet,
        }) 
        if (close) {
          this.$emit('close')
        } else {
          await this.$emit('refreshStatus')
        }
      } catch(err) {
        console.log(err)
        this.$emit('toggleError', true)
      } finally {
        this.$emit('setIsLoading', false)
      }
    },
    async cancelRefund () {
      try {
        this.$emit('toggleError', false)
        this.$emit('setIsLoading', true)
        await apiHelper.post('/refund/cancel', {
          source_wallet: this.status.source_wallet
        })
        this.$emit('close')
      } catch(err) {
        console.log(err)
        this.$emit('toggleError', true)
      } finally {
        this.$emit('setIsLoading', false)
      }
    }
  },
  computed: {
    ...mapGetters([
      vuexTypes.accountBalances,
      vuexTypes.userEmail
    ]),
    sumTron () {
      // Every network token the account holds, grey (D) balances included
      let sum = Object.keys(this.accountBalances)
        .filter(code => getTokenNetwork(code) !== null)
        .reduce((partialSum, code) => partialSum + +this.accountBalances[code].balance, 0)

      sum = sum.toFixed(6).replace(/0+$/, '').replace(/\.$/, '')
      return sum
    },
    isDisabledRefund () {
      return this.isLoading || !this.wallet
    },
    isDisabledCancel () {
      return this.isLoading
    }
  }
}
</script>

<style scoped lang="scss">
  @import '~scss/variables';
  @import '~scss/mixins';
.mt-30 {
  margin-top: 30px;
}
.refund-wrap {
  min-width: 500px;
  .refund-content {
    margin-top: 30px;
  }
}
.refund-timer {
  padding-left: 0;
  margin-bottom: 30px;
  justify-content: flex-start;
}
.orange {
    color: $col-pending;
  }

  .grey {
  background-color: $gray_asset !important;
}
/deep/ .md-field.grey label  {
 
  background-color: $gray_asset !important;

}
</style>


// WEBPACK FOOTER //
// src/vue/navigation/RefundModal.vue